import { TabList } from "@mui/lab";
import {
  Avatar,
  Chip,
  IconButton,
  Menu,
  styled,
  TableCell,
  TableRow,
} from "@mui/material";
import Tippy from "@tippyjs/react";
import { RadarChart } from "recharts";

export const PrimaryDiv = styled("div")`
  border: 1px solid #eaecf0;
  border-radius: 10px;
  padding: 12px 15px;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
  height: 100%;
`;

export const SecondaryShift = styled("div")`
  display: flex;
  gap: 10px;
  align-items: center;
  flex-wrap: wrap;
`;

export const CustomizeTableCell = styled(TableCell)(
  ({
    fontWeight,
    display,
    justifyContent,
    gap,
    alignItems,
    textAlign,
    verticalAlign,
    width,
    background,
    padding,
  }) => ({
    fontWeight: `${fontWeight} !important`,
    display: display,
    justifyContent: justifyContent,
    gap: gap,
    alignItems: alignItems,
    textAlign: textAlign,
    width: width,
    verticalAlign: verticalAlign,
    background: background,
    cursor: "auto",
    padding: padding,
  })
);

export const CustomizeTableRow = styled(TableRow)(
  ({ display, justifyContent, marginBottom, alignItems, textAlign }) => ({
    display: display,
    justifyContent: justifyContent,
    marginBottom: marginBottom,
    alignItems: alignItems,
    textAlign: textAlign,
  })
);

export const SkillCriticality = styled("div")`
  width: 100%;
  gap: 10px;
  display: flex;
  align-items: center;
`;

export const SelectCreateCard = styled("div")`
  border: 1px solid #eaecf0;
  border-radius: 15px;
  padding: 1.2rem 1rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
`;

export const CustomTooltipField = styled("div")(
  ({ fontSize, padding, size, fontWeight, top }) => ({
    position: "absolute",
    top: top || "-40px",
    left: "50%",
    transform: "translateX(-50%)",
    backgroundColor: "red",
    color: "#fff",
    padding: padding || "5px",
    fontSize: fontSize || "12px",
    borderRadius: "4px",
    whiteSpace: "nowrap",
    fontWeight: fontWeight,
    zIndex: 1000,
    "&::before": {
      content: '" "',
      position: "absolute",
      bottom: `-${size - 1}px`,
      left: "50%",
      transform: "translateX(-50%)",
      width: "0",
      height: "0",
      borderLeft: `${size}px solid transparent`,
      borderRight: `${size}px solid transparent`,
      borderTop: `${size}px solid red`,
    },
  })
);

export const CommonTippy = styled(Tippy)(
  ({
    color,
    fontWeight,
    fontSize,
    textAlign,
    bottom,
    maxWidth,
    lineHeight,
  }) => ({
    backgroundColor: `${color} !important`,
    fontWeight: fontWeight,
    textAlign: textAlign,
    fontSize: `${fontSize} !important`,
    bottom: bottom,
    maxWidth: `${maxWidth} !important`,
    lineHeight: `${lineHeight} !important`,

    "& .tippy-arrow": {
      color: `${color}`,
    },
  })
);

export const ErrorContent = styled("div")(({ fontSize, margin }) => ({
  margin: margin || "0px",
  fontSize: fontSize || "12px",
  fontWeight: "600",
  color: "#d32f2f",
}));
export const TooltipParagraph = styled("p")(
  ({
    color,
    fontWeight,
    textAlign,
    fontSize,
    display,
    justifyContent,
    gap,
    flexDirection,
  }) => ({
    margin: "0px",
    fontSize: fontSize,
    fontWeight: fontWeight || 700,
    textAlign: textAlign,
    color: color,
    justifyContent: justifyContent,
    display: display,
    flexDirection: flexDirection,
    gap: gap,
  })
);

export const EllipseData = styled("span")(
  ({ width, textTransform, display, padding, maxWidth }) => ({
    whiteSpace: "nowrap",
    width: width,
    overflow: "hidden",
    textOverflow: "ellipsis",
    display: display || "inline-block",
    textTransform: textTransform,
    padding: padding,
    maxWidth: maxWidth,
  })
);

export const ToogleParentContainer = styled("div")(() => ({
  border: "1px solid #EAECF0",
  backgroundColor: "#EAECF0",
  padding: "4px",
  borderRadius: "5px",
}));

export const ChatBotRelative = styled("div")(
  ({ bottom, height, zIndex, right }) => ({
    position: "fixed",
    bottom: bottom,
    zIndex: zIndex || 999,
    height: height,
    right: right || "1.5rem",
  })
);

export const CustomizeMenu = styled(Menu)(() => ({
  "& .MuiPaper-root": {
    marginTop: "5px",
    borderRadius: "5px",
    boxShadow: "0px 1px 5px 0px rgb(116 58 235 / 43%)",
    // border: "1px solid rgb(127 86 217 / 51%)",
  },
}));

export const CustomizeSpan = styled("span")(
  ({
    color,
    fontWeight,
    top,
    left,
    position,
    cursor,
    fontSize,
    textTransform,
    width,
    whiteSpace,
    overflow,
    textOverflow,
    display,
    margin,
    padding,
    border,
    borderRadius,
    background,
    alignItems,
    customStyle,
    lineHeight,
    maxHeight = "fit-content",
  }) => ({
    color: color,
    fontWeight: fontWeight,
    top: top,
    left: left,
    position: position,
    cursor: cursor,
    fontSize: fontSize,
    textTransform: textTransform,
    width: width,
    whiteSpace: whiteSpace,
    textOverflow: textOverflow,
    overflow: overflow,
    display: display,
    margin: margin,
    padding: padding,
    borderRadius: borderRadius,
    border: border,
    background: background,
    alignItems: alignItems,
    lineHeight: lineHeight,
    maxHeight: maxHeight,
    ...customStyle,
  })
);

export const CustomizeChip = styled(Chip)(() => ({
  border: "1px solid #7F56D9",
  borderRadius: "5px",
  gap: "10px",
  color: "#7F56D9",
  fontWeight: "600",
  background: "rgb(105 65 198 / 13%)",
  "& svg": {
    fill: "#7F56D9",
  },
}));

export const CustomAvatar = styled(Avatar)(
  ({ width, height, borderRadius, margin }) => ({
    width: width,
    height: height,
    borderRadius: borderRadius,
    margin: margin,
  })
);

export const CustomOrderList = styled("ol")(
  ({ padding, margin, gap, fontSize }) => ({
    padding: padding,
    margin: margin,
    display: "flex",
    flexDirection: "column",
    gap: gap,
    li: {
      fontSize: fontSize,
      color: "#00144A",
      fontWeight: 500,
      fontFamily: "Inter",
    },
  })
);

export const CustomUnOrderList = styled("ul")(
  ({ padding, margin, gap, fontSize }) => ({
    padding: padding,
    margin: margin,
    display: "flex",
    flexDirection: "column",
    gap: gap,
    li: {
      fontSize: fontSize,
      color: "#00144A",
      fontWeight: 500,
      fontFamily: "Inter",
    },
  })
);

export const TabCardSection = styled(TabList)(({ breakpoint }) => ({
  width: "100%",

  "& .MuiTabs-flexContainer": {
    justifyContent: "space-between",
    gap: "1.5rem",
  },
  "& .Mui-selected": {
    background: "#FCF9FF",
    color: "#344054 !important",
    boxShadow: "0px 0px 1px 0px #101828",
    borderRadius: "5px",
    border: "1px solid #7F56D9 !important",
  },
  "& .MuiTab-root": {
    padding: "1.5rem 1rem 1rem",
    color: "#667085",
    fontWeight: 600,
    fontFamily: "Inter",
    border: "1px solid #EAECF0",
    borderRadius: "10px",

    // width: "170px",
    // flex: "none",

    // [theme.breakpoints.down("md")]: {
    //   width: "200px",
    //   flex: "none",
    // },
    // [theme.breakpoints.up("md")]: {
    //   flex: 1,
    //   // width: "200px",
    // },

    [`@media (max-width:${breakpoint}px)`]: {
      width: "200px",
      flex: "none",
    },
    [`@media (min-width:${breakpoint}px)`]: {
      flex: 1,
      // width: "200px",
    },
  },
  "& .MuiTabs-indicator": {
    display: "none",
  },
  "& .Mui-disabled": {
    opacity: "0.6 !important",
    background: "#8080801f !important",
  },
  "& .MuiTabScrollButton-horizontal": {
    borderRadius: "7px",
    boxShadow: "0px 0px 1px 0px #101828",
    height: "-webkit-fill-available",
    padding: "10px",
    margin: "auto 1rem",
  },
  "& .MuiTabs-scrollButtonsHideMobile": {
    height: "auto",
  },
}));

export const AcheivementsCard = styled("div")(
  ({ gap = "1rem", padding = "1.2rem 1rem", width }) => ({
    border: "1px solid #eaecf0",
    borderRadius: "15px",
    padding: padding,
    display: "flex",
    flexDirection: "column",
    gap: gap,
    boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
    minWidth: "18%",
  })
);

export const CustomToogleStyle = styled("div")(() => ({
  "& .MuiTab-root": {
    minHeight: "auto !important",
    padding: "5px 1.5rem",
    fontWeight: 700,
    minWidth: "auto",
  },
  "& .MuiToggleButtonGroup-root": {
    padding: "3px 3px 3px 0px",
  },
  "& .MuiToggleButton-root": {
    border: "0px !important",
    padding: "8px 1rem",
  },
  "& .Mui-selected": {
    background: "#7F56D9 !important",
    margin: "0px",
    padding: "5px 1rem",
    color: "#fff !important",
    boxShadow: "0px 0px 1px 0px #101828",
    borderRadius: "5px",
  },
}));

export const CustomIconButton = styled(IconButton)(({ padding }) => ({
  padding: padding,
}));

export const CustomizeRadarChart = styled(RadarChart)(() => ({
  "& .recharts-legend-wrapper": {
    width: "max-content !important",
  },
}));
